// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/SCSS/main.scss
 ** module id = 225
 ** module chunks = 0
 **/